<template>
  <div id="app">
    <keep-alive  :include="cachedRoutes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  computed: {
    cachedRoutes() {
      return this.$route.meta.noCache ? [] : ["Dashboard"]; // 根据 meta 字段决定是否缓存
    },
  },
  created() {
    let that= this;
    if(window.sessionStorage.getItem("userId")!=null){

    }else {
      setTimeout(function () {
        that.$router.push({path:'/login'})
      },500)
    }

  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue